import gql from 'graphql-tag';

export const APPLY_EVENT_ATTENDEE = gql`
  mutation applyEventAttendee($eventId: Int!, $numTickets: Int!) {
    applyEventAttendee(eventId: $eventId, numTickets: $numTickets) {
      id
    }
  }
`;

export const SEND_NOTE = gql`
  mutation updateEventAttendeeNote($message: String!, $eventId: Int!) {
    updateEventAttendeeNote(message: $message, eventId: $eventId) {
      success
    }
  }
`;

export const UPDATE_EVENT_ATTENDEE_STATE_FOR_USER = gql`
  mutation updateEventAttendeeStateForUser($eventId: Int!, $state: String!) {
    updateEventAttendeeStateForUser(eventId: $eventId, state: $state) {
      id
      currentState
    }
  }
`;

export const UPDATE_EVENT_ATTENDEE_VISIBLE_TO_USER = gql`
  mutation updateEventAttendeeVisibleToUser(
    $eventId: ID!
    $token: String!
    $visibleToUser: Boolean
  ) {
    updateEventAttendeeVisibleToUser(
      eventId: $eventId
      token: $token
      visibleToUser: $visibleToUser
    ) {
      success
      eventAttendee {
        id
        currentState
        source
        skipPayment
        totalTicketCost
        hasAppliedPromoCode
        visibleToUser
        tickets {
          id
          firstName
          lastName
          email
          primary
        }
      }
    }
  }
`;

export const UPDATE_EVENT_ATTENDEE_OCCASION = gql`
  mutation updateEventAttendeeOccasion(
    $eventId: Int!
    $occasion: String
    $occasionDetails: String
  ) {
    updateEventAttendeeOccasion(
      eventId: $eventId
      occasion: $occasion
      occasionDetails: $occasionDetails
    ) {
      success
      eventAttendee {
        id
        occasion
        occasionDetails
      }
    }
  }
`;
